import React from 'react';
import styled from 'styled-components';
import { ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import { Button } from '@monolith/components/0-atoms/Button';
import OpusModal from '@monolith/components/0-atoms/OpusModal';
import { staffImportTokens } from '../styles/staffImportTokens';

export interface StaffImportWarningModalProps {
    isOpen: boolean;
    modalName: string;
    title: string;
    message: string;
    dismissLabel: string;
    confirmLabel: string;
    dismissButtonId: string;
    confirmButtonId: string;
    onDismiss: () => void;
    onConfirm: () => void;
}

const Message = styled.p`
    margin: 0;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    line-height: 20px;
    color: #212121;
`;

const FooterActions = styled(ModalFooter)`
    display: flex;
    justify-content: flex-end;
    gap: ${staffImportTokens.spacing.sectionGap}px;
`;

const DismissButton = styled(Button)`
    color: ${staffImportTokens.colors.destructive};
`;

export const StaffImportWarningModal: React.FC<
    StaffImportWarningModalProps
> = ({
    isOpen,
    modalName,
    title,
    message,
    dismissLabel,
    confirmLabel,
    dismissButtonId,
    confirmButtonId,
    onDismiss,
    onConfirm,
}) => {
    return (
        <OpusModal
            centered
            isOpen={isOpen}
            toggle={onDismiss}
            modalName={modalName}
            wrapClassName="modal-primary modal-fit-content"
        >
            <ModalHeader toggle={onDismiss}>{title}</ModalHeader>
            <ModalBody>
                <Message>{message}</Message>
            </ModalBody>
            <FooterActions>
                <DismissButton
                    id={dismissButtonId}
                    variant="text-only"
                    size="small"
                    onClick={onDismiss}
                >
                    {dismissLabel}
                </DismissButton>
                <Button
                    id={confirmButtonId}
                    variant="primary"
                    size="small"
                    onClick={onConfirm}
                >
                    {confirmLabel}
                </Button>
            </FooterActions>
        </OpusModal>
    );
};

export default StaffImportWarningModal;
